const Teams = (props) => {
  return (
    <div>
      <p>Equipes</p>
    </div>
  )
}

export default Teams;
